(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/views/self-exclusion.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/views/self-exclusion.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.self_exclusion_react=_svs.self_exclusion_react||{};
_svs.self_exclusion_react.templates=_svs.self_exclusion_react.templates||{};
svs.self_exclusion_react.templates.self_exclusion = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"f-content js-react-container\"></div>\n";
},"useData":true});
Handlebars.partials['svs-self_exclusion_react-self_exclusion'] = svs.self_exclusion_react.templates.self_exclusion;
})(svs, Handlebars);


 })(window);